import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "acoes-item"
}
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { key: 3 }
const _hoisted_7 = { key: 4 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", {
  class: "ant-divider ant-divider-horizontal",
  role: "separator",
  style: {"margin-top":"10px","margin-bottom":"0"}
}, null, -1)
const _hoisted_9 = {
  class: "ant-row",
  style: {"margin-top":"8px"}
}
const _hoisted_10 = {
  class: "ant-col",
  style: {"flex":"auto 1 1"}
}
const _hoisted_11 = { class: "ant-col ant-col-xs-12 ant-col-xl-3" }
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "ant-col ant-col-xs-12 ant-col-xl-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_icone = _resolveComponent("icone")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_campo_numerico = _resolveComponent("campo-numerico")!
  const _component_cte_documento_referenciado_modal = _resolveComponent("cte-documento-referenciado-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_table, {
      columns: _ctx.colunas,
      "data-source": _ctx.props.documentos,
      rowKey: "chaveAcessoDocumento",
      pagination: false,
      scroll: { y: 220 },
      size: "small"
    }, {
      emptyText: _withCtx(() => [
        _createVNode(_component_mensagem_sem_dados, { mensagem: "Nenhum documento referenciado adicionado ainda" })
      ]),
      bodyCell: _withCtx(({ column, record, index }) => [
        (column.key === 'acoes')
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("a", {
                class: "visualizar",
                onClick: ($event: any) => (_ctx.editarDocumento(index))
              }, [
                _createVNode(_component_icone, { nome: "editar" })
              ], 8, _hoisted_2),
              (_ctx.props.editavel)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    class: "excluir",
                    onClick: ($event: any) => (_ctx.excluirDocumento(index))
                  }, [
                    _createVNode(_component_icone, { nome: "excluir" })
                  ], 8, _hoisted_3))
                : _createCommentVNode("", true)
            ]))
          : (column.key === 'valorDocumento')
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.valorDocumento, 2, true)), 1))
            : (column.key === 'pesoDocumento')
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.pesoDocumento, 3, false)), 1))
              : (column.key === 'valorFretePorDocumento')
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.valorFretePorDocumento, 2, true)), 1))
                : (column.key === 'chaveAcessoDocumento')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(record.chaveAcessoDocumento || record.chaveAcesso || record.ChaveAcessoDocumento || ''), 1))
                  : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["columns", "data-source"]),
    _hoisted_8,
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_a_form_item, {
          label: " ",
          class: "ss-margin-campos"
        }, {
          default: _withCtx(() => [
            (_ctx.props.editavel)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "ant-btn ant-btn-secondary ss-acao-destaque-secundaria",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.adicionarDocumento && _ctx.adicionarDocumento(...args)))
                }, " Inserir documento "))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_a_form_item, {
          label: "Quantidade",
          class: "ss-margin-campos"
        }, {
          default: _withCtx(() => [
            _createElementVNode("input", {
              type: "text",
              class: "ant-input",
              style: {"text-align":"right"},
              value: _ctx.props.documentos.length,
              disabled: "true"
            }, null, 8, _hoisted_12)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_a_form_item, {
          label: "Total documentos",
          class: "ss-margin-campos"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_campo_numerico, {
              quantidadeCasasDecimais: 2,
              valor: _ctx.totalDocumentos,
              disabled: true
            }, null, 8, ["valor"])
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(_component_cte_documento_referenciado_modal, {
      visivel: _ctx.state.exibirModal,
      "onUpdate:visivel": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.exibirModal) = $event)),
      documento: _ctx.state.documentoSelecionado,
      indexEdicao: _ctx.state.indexSelecionado,
      onConfirmar: _ctx.confirmarDocumento
    }, null, 8, ["visivel", "documento", "indexEdicao", "onConfirmar"])
  ]))
}